import React, { createContext, FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getHashPath } from './getHashPath';
import { setHashPath } from './setHashPath';

export const LastRouteContext = createContext({
  lastRoute: '',
  clearLastRoute: (): void => {}
});

/**
 * Captures window.location.hash before window unloads, provides "lastRoute" as a state for <App> or deeper nested components
 * @param children
 * @constructor
 */
export const LastRouteProvider: FC<any> = ({ children }) => {
  const [lastRoute, setLastRoute] = useState(localStorage.getItem('lastRoute') || '');
  const location = useLocation();

  const updateHashPath = () => {
    const path = getHashPath();

    if (path) {
      setHashPath(path);
    }
  }

  useEffect(() => {
    const handleHashChange = (event: any) => {
      updateHashPath();
    };

    window.addEventListener('hashchange', handleHashChange, false);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      updateHashPath();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const clearLastRoute = () => {
    localStorage.removeItem('lastRoute');
    setLastRoute('');
  }

  return (
    <LastRouteContext.Provider value={{ lastRoute, clearLastRoute }}>
      { children }
    </LastRouteContext.Provider>
  )
};
